import {cachifyPromise} from 'cachify-promise';
import {api} from '../../config';
import type {Channel} from '../types/account-api/ChannelOutput';
import type {
  InfoPageOutput,
  InfoPageType,
} from '../types/rainbow-api/InfoPageOutput';
import {getHeaderLanguageCode, getLanguageCode} from '../utils/language';
import {httpGetJson} from './http';

export function composeFetchChannel(baseUrl = '') {
  const fetchChannel = async () => {
    const headers = getHeaderLanguageCode(
      getLanguageCode(window.location.pathname)
    );
    return httpGetJson<Channel>({
      path: `${baseUrl}${api.rainbowApiClient}/channel`,
      options: {headers},
    });
  };
  return cachifyPromise(fetchChannel);
}

export const fetchChannel = composeFetchChannel();

export function composeFetchInfoPageContent(baseUrl = '') {
  const fetchInfoPageContent = async (types: InfoPageType[]) => {
    return httpGetJson<InfoPageOutput[]>({
      path: `${baseUrl}${api.rainbowApiClient}/content/info/${types.join(',')}`,
    });
  };
  return cachifyPromise(fetchInfoPageContent);
}

export const fetchInfoPageContent = composeFetchInfoPageContent();
